import { Pressable, StyleSheet, View } from 'react-native';
import { tokens } from '../../theme/tokens';
import type { LearningAnalysisRange } from '../../types/learningAnalysis';
import { AppText } from '../ui/AppText';

type LearningTimeFilterProps = {
  activeRange: LearningAnalysisRange;
  onChangeRange: (range: LearningAnalysisRange) => void;
};

const ranges: Array<{ id: LearningAnalysisRange; label: string }> = [
  { id: 'week', label: '本周' },
  { id: 'month', label: '本月' },
  { id: 'term', label: '本学期' },
];

export function LearningTimeFilter({ activeRange, onChangeRange }: LearningTimeFilterProps) {
  return (
    <View style={styles.wrapper}>
      {ranges.map((range) => {
        const active = activeRange === range.id;
        return (
          <Pressable
            key={range.id}
            accessibilityRole="button"
            onPress={() => onChangeRange(range.id)}
            style={[styles.filterButton, active ? styles.filterButtonActive : null]}
          >
            <AppText
              variant="caption"
              weight="bold"
              tone={active ? 'default' : 'primary'}
              style={active ? styles.activeLabel : null}
            >
              {range.label}
            </AppText>
          </Pressable>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    gap: tokens.spacing.sm,
  },
  filterButton: {
    flex: 1,
    minHeight: 38,
    borderRadius: tokens.radius.full,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colors.surfaceMuted,
  },
  filterButtonActive: {
    backgroundColor: tokens.colors.primary,
  },
  activeLabel: {
    color: tokens.colors.white,
  },
});
